<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-btn color="primary" @click="() => $router.push({name: 'Organizations'})">К списку организаций</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center">
                <orgnization-form></orgnization-form>
            </v-row>
        </v-card-text>
    </v-card>

</template>

<script>
import OrgnizationForm from '@/components/Organization/OrgnizationForm.vue';
export default {
    name: 'OrganizationsAdd',
    components:{
        OrgnizationForm,
    },
    data(){
        return {
        }
    },
    methods: {

    },
    computed: {
    }
}
</script>